var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 16 16",
    viewBox: "0 0 16 16",
    id: "Checkmark",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8,0C3.582,0,0,3.582,0,8s3.582,8,8,8s8-3.582,8-8 S12.418,0,8,0z M11.72,6.633L7.662,10.69c-0.374,0.374-0.979,0.374-1.353,0L4.28,8.662c-0.374-0.373-0.374-0.979,0-1.353 c0.374-0.374,0.979-0.374,1.353,0l1.353,1.353l3.382-3.382c0.374-0.374,0.979-0.374,1.353,0S12.094,6.259,11.72,6.633z",
    clipRule: "evenodd",
    fill: "#9aca3c",
    className: "color000000 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkGreen);
export default __webpack_public_path__ + "static/media/checkmark-green.338b74b6cf54f996517cb8f9a4e15230.svg";
export { ForwardRef as ReactComponent };